import { RegisterAsIndividualIcon } from "@/assets";
import NewUsersIcon24 from "@/assets/SVG/newUsersIcon24";
import TripIcon24 from "@/assets/SVG/TripIcon24";
import Card from "@/pages/admin/dashboard/components/Card";
import { Grid } from "@mui/material";

function JahadgarStats({ activeTripsStats }) {
  return (
    <>
      <Grid display={"flex"} flexDirection={"column"} gap={"20px"}>
        {activeTripsStats
          .filter((itr) => !itr.isOwner)
          .map((tripStat, index) => (
            <Grid
              key={index}
              display={"flex"}
              flexDirection={"column"}
              gap={"10px"}
            >
              {`${tripStat.name} - ${tripStat.city}`}
              {tripStat.moduleStats &&
                tripStat.moduleStats.map((moduleStat, index) => (
                  <Grid
                    key={index}
                    display={"flex"}
                    flexDirection={"row"}
                    gap={"10px"}
                    flexWrap={"wrap"}
                    rowGap={"20px"}
                  >
                    <Card
                      title={"سمت شما"}
                      icon={<TripIcon24 />}
                      counter={`مسئول ${moduleStat.name}`}
                    />
                    <Card
                      title={"مراجعین"}
                      icon={<RegisterAsIndividualIcon />}
                      counter={moduleStat.patients}
                      unit={"نفر"}
                    />
                    <Card
                      title={"مراجعین در انتظار"}
                      icon={<NewUsersIcon24 />}
                      counter={moduleStat.waitingPatients}
                      unit={"نفر"}
                    />
                    <Card
                      title={"مراجعین پذیرش شده"}
                      icon={<NewUsersIcon24 />}
                      counter={moduleStat.receptedPatients}
                      unit={"نفر"}
                    />

                    <Card
                      title={"مراجعین پذیرش شده توسط شما"}
                      icon={<NewUsersIcon24 />}
                      counter={moduleStat.receptedByMe}
                      unit={"نفر"}
                    />
                  </Grid>
                ))}
            </Grid>
          ))}
      </Grid>
    </>
  );
}

export default JahadgarStats;
